module.exports = __webpack_public_path__ + "thavRedBigMobile.png?50e8e8ca3df506831367b664e227f9be";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thavRedBigMobile.png
// module id = 15
// module chunks = 0